import React from "react";
import InputField from "../InputField/InputField";
import { FaUserPen } from "react-icons/fa6";
import { RiIdCardFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import ActionButton from "./ActionButton/ActionButton";
import PhoneNumberField from "../InputField/PhoneNumberField";
const Step1 = ({ formik, customHandleChange, handleNext, t, direction }) => {
  // Input field configuration array
  const inputFields = [
    // { 
    //   label: t.phoneNumber,
    //   name: "phone",
    //   icon: <FaPhoneAlt style={{ marginRight: "8px", color: "#C49A6C" }} />,
    //   required: true,
    //   placeholder: t.enterPhoneNumber
    // },
    {
      label: t.name,
      name: "name",
      icon: <FaUserPen style={{ marginRight: "8px", color: "#C49A6C" }} />,
      required: true,
      placeholder: t.enterName
    },
    {
      label: t.idNumber,
      name: "idNumber",
      icon: <RiIdCardFill style={{ marginRight: "8px", color: "#C49A6C" }} />,
      required: true,
      placeholder: t.enterIdNumber
    },
    {
      label: t.email,
      name: "email",
      type: "email",
      icon: <MdEmail style={{ marginRight: "8px", color: "#C49A6C" }} />,
      placeholder: t.enterEmail
    },
  ];
  return (
    < >
     <PhoneNumberField
        formik={formik}
        customHandleChange={customHandleChange}
        t={t}
        direction={direction}
      />
      {inputFields.map((field, index) => (
        <InputField
          key={index}
          label={field.label}
          name={field.name}
          type={field.type || "text"}
          value={formik.values[field.name]}
          onChange={customHandleChange}
          onBlur={formik.handleBlur}
          error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
          helperText={formik.touched[field.name] && formik.errors[field.name]}
          icon={field.icon}
          required={field.required}
          placeholder={field.placeholder}
          direction={direction}
          t={t}
        />
      ))}

      <ActionButton
        onClick={handleNext}
        label={t.next}
        color="var(--primary-color)"
        disabled={!formik.isValid || formik.isSubmitting}
        hovercolor="var(--primary-color-dark)"
      />
    </>
  );
};

export default Step1;
